<app-denials-multilevel-chart
  [page]="currentPage"
  [graphData]="denialsMultiLevel"
  [isDepartment]="true"
  [isSpecialty]="false"
  [isProvider]="false"
  [tabLevel]="1"
  [level]="'By Department'"
  [showProgressBar]="showProgressBar"
  [benchmarkType]="benchmarkType"
  [variables]="variables"
  [showVariableMenu]="true"
  [activeVarianceToggle]="activeVarianceToggle"
  [columnSelectionCallback]="whenDepartmentSelected">
</app-denials-multilevel-chart>
<app-denials-metric-data-table id="denials-data-table"
                               [showProgressBar]="showProgressBar"
                               [rowSelectionCallback]="whenDepartmentSelected"
                               [sortingDataAccessor]="sortingDataAccessor"
                               [receivedData]="denialsMultiLevel"
                               [columns]="columns"
                               [originalColumns]="originalColumns"
                               [defaultSortColumn]="defaultSortColumn"
                               [shouldPutNullsAtTheBottom]="activeVarianceToggle"
                               [sortDirection]="sortDirection"
                               [tableTitle]="'Denial Analysis By Department'"
                               [whenSortChanged]="levelSpecificHandleSortChange"
                               [denialsTab]="true"
                               [benchmarkType]="benchmarkType"
                               [currentPage]="currentPage"
                               [updateSortingCriteria]="updateSortingCriteria"
                               [reducerAction]="reducerAction"
                               [addRemoveOption]="true"
                               [nodePathName]="nodePathName"
></app-denials-metric-data-table>
